import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { stripReferenciaDocumento } from "./stripReferenciaDocumento.js"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export { stripReferenciaDocumento }

/**
 * Normaliza valor de hora para uso em <input type="time"> (HH:mm).
 * Remove referência de documento e extrai apenas hora e minuto.
 * @param {string} value - Valor que pode conter referência (ex: "Primeira página - 09h") ou "09:00"
 * @returns {string} "HH:mm" ou "" se não for possível extrair
 */
export function horaParaInputTime(value) {
  if (value == null || typeof value !== 'string') return '';
  const s = stripReferenciaDocumento(value).trim();
  if (!s || s === 'Não localizado') return '';
  if (/^\d{2}:\d{2}(:\d{2})?/.test(s)) return s.slice(0, 5);
  const match = s.match(/(\d{1,2})h(\d{2})?/i) || s.match(/(\d{1,2}):(\d{2})/);
  if (match) {
    const h = match[1].padStart(2, '0');
    const min = (match[2] || '00').padStart(2, '0');
    return `${h}:${min}`;
  }
  if (/^\d{1,2}$/.test(s)) return s.padStart(2, '0') + ':00';
  return '';
}

/** Valores canônicos do Modo de Disputa (Lei 14.133 / Compras.gov). */
export const MODO_DISPUTA_OPCOES = ["Aberto", "Fechado", "Aberto e Fechado"];

/**
 * Padroniza modo de disputa apenas para: Aberto | Fechado | Aberto e Fechado.
 * Retorna null se não for um dos três.
 */
export function normalizarModoDisputa(valor) {
  if (!valor || typeof valor !== "string") return null;
  const s = stripReferenciaDocumento(valor).trim();
  if (!s || /^n[ãa]o\s+localizado/i.test(s)) return null;
  const lower = s.toLowerCase().replace(/\s+/g, " ");
  if (
    (/\baberto\b/.test(lower) && /\bfechado\b/.test(lower)) ||
    lower.includes("aberto e fechado") ||
    lower.includes("aberto/fechado") ||
    lower.includes("aberto-fechado")
  ) {
    return "Aberto e Fechado";
  }
  if (/\baberto\b/.test(lower)) return "Aberto";
  if (/\bfechado\b/.test(lower)) return "Fechado";
  return null;
}

export const isIframe =
  typeof window !== 'undefined' && window.self !== window.top;
